import { ReactNode } from 'react';
import { Field } from 'formik';
import cn from 'classnames';
import s from '../Dropdowns.module.less';
import FieldWrapper from '../../FieldWrapper';
import RawSelect from '../RawSelect';
import { OptionType, SelectValue } from '../types';

export type Props = {
  name: string;
  labelText?: ReactNode;
  required?: boolean;
  options: OptionType[];
  value?: string | null;
  isClearable?: boolean;
  placeholder?: string;
  labelClass?: string;
  containerClass?: string;
  className?: string;
  isMulti?: boolean;
  isDisabled?: boolean;
  'data-testid'?: string;
  components?: any;
  onSelect: (val: SelectValue) => void;
};

const Select = ({
  name,
  labelText,
  required = false,
  options,
  value,
  isClearable = true,
  placeholder,
  labelClass,
  containerClass,
  isDisabled = false,
  className,
  'data-testid': dataTestId,
  components,
  onSelect,
  isMulti = false,
}: Props) => (
  <FieldWrapper
    name={name}
    labelText={labelText}
    required={required}
    labelClass={labelClass}
    containerClass={containerClass}
    data-testid={dataTestId}
  >
    <Field name={name}>
      {({ field, form, meta }) => (
        <RawSelect
          name={field.name}
          className={cn(className, meta.error && meta.touched && s.error)}
          placeholder={placeholder}
          value={value || field.value}
          onChange={async newValue => {
            onSelect(newValue);
            form.setFieldTouched(field.name, true);
          }}
          onBlur={field.onBlur}
          options={options}
          isClearable={isClearable}
          isDisabled={isDisabled}
          components={components}
          isMulti={isMulti}
        />
      )}
    </Field>
  </FieldWrapper>
);

export default Select;
